import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'meterDetails',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    ImagesComp: require('./customerImages.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      loading: false,
      menuVisible: true,
      lang: '',
      selectedTab: 'meter',
      scrollAmt: 200,
      MeterId: 0,
      tabs: [],
      meterType: [],
      meterMake: [],
      meterSize: [],
      meterCondition: [],
      warehouse: [],


      meter: {},
      readings: [],
      readingsCols: [],
      history: [],
      historyCols: [],
      installationDate: null,

      readingsPageingOptions: { pageSize: 10, total: 0, page: 1 },
      readingsTotalRow: 0,
      historyPageingOptions: { pageSize: 10, total: 0, page: 1 },
      historyTotalRow: 0,
    }
  },
  computed: {
    selectedTabObj: function () {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    },
    isRtl: function () {
      return this.lang == 'ar' ? true : false;
    }
  },
  watch: {
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrl(val);
    },
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.MeterId = this.$route.params.MeterId;

    this.fillReadingsCols();
    this.fillHistoryCols();

    this.tabs = [
      {
        id: 'meter',
        show: true,
        ...this.enqIcons.meter
      },
      {
        id: 'readings',
        show: true,
        ...this.enqIcons.readings
      },
      {
        id: 'images',
        show: true,
        ...this.enqIcons.images
      },
      {
        id: 'history',
        show: true,
        ...this.enqIcons.history
      }
    ];

    this.findDefaultTab();
  },
  mounted() {
    this.fillLookUps();
  },
  methods: {
    fillReadingsCols() {
      this.readingsCols = [];
      this.readingsCols.push({ dataField: 'rdgDate', caption: this.$t('enquiriesMeterDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.readingsCols.push({ dataField: 'reading', caption: this.$t('enquiriesMeterDetails.reading') });
      this.readingsCols.push({ dataField: 'consumption', caption: this.$t('enquiriesMeterDetails.consumption') });
      this.readingsCols.push({ dataField: 'flow', caption: this.$t('enquiriesMeterDetails.flow') });
      this.readingsCols.push({ dataField: 'reasonDescription', caption: this.$t('enquiriesMeterDetails.reason') });
      this.readingsCols.push({ dataField: 'isInvoiced', caption: this.$t('enquiriesMeterDetails.invoiced') });
    },
    fillHistoryCols() {
      this.historyCols = [];
      this.historyCols.push({ dataField: 'operation', caption: this.$t('enquiriesMeterDetails.operation') });
      this.historyCols.push({ dataField: 'connection', caption: this.$t('enquiriesMeterDetails.connection') });
      this.historyCols.push({ dataField: 'srcWarehouse', caption: this.$t('enquiriesMeterDetails.srcWarehouse') });
      this.historyCols.push({ dataField: 'dstWarehouse', caption: this.$t('enquiriesMeterDetails.dstWarehouse') });
      this.historyCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesMeterDetails.stampUser') });
      this.historyCols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesMeterDetails.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
    },
    fillLookUps() {
      this.loading = true;

      axios.post('/Enquiries/GetMeterDetailsLookups', { Value: this.getLoginName() })
        .then(response => {
          if (response.status == 200) {
            this.meterType = response.data.meterTypes;
            this.meterMake = response.data.meterMakes;
            this.meterSize = response.data.meterSizes;
            this.meterCondition = response.data.meterConditions;
            this.warehouse = response.data.meterWarehouse;

            this.getMeterData();
          }
        })
        .catch(e => { this.loading = false; })
    },
    getMeterData() {
      var parameters = {
        meterId: this.MeterId,
        loginEmail: this.getLoginName()
      }

      axios.post('/Enquiries/GetMeterData', parameters)
        .then(response => {
          if (response.status == 200) {

            this.installationDate = this.$options.filters.formatDateDDMMYYY(response.data.meterData.installationDate);
            this.meter = response.data.meterData;
            this.meter.typeDisplay = this.meter.type ? this.meterType.filter(t => t.id == this.meter.type)[0].describe : '';
            this.meter.makeDisplay = this.meter.make ? this.meterMake.filter(t => t.id == this.meter.make)[0].describe : '';
            this.meter.sizeDisplay = this.meter.size ? this.meterSize.filter(t => t.id == this.meter.size)[0].describe : '';
            this.meter.conditionDisplay = this.meter.condition ?this.meterCondition.filter(t => t.id == this.meter.condition)[0].describe : '';
            this.meter.warehouseDisplay = this.meter.warehouseId && this.meter.warehouseId >= 0 ? this.warehouse.filter(t => t.id == this.meter.warehouseId)[0].describe : '';
          }
        })
        .then(a => {
          this.fillReadings();
          this.fillHistory();
        })
        .catch(e => {
          console.log("err", e);
          this.loading = false;
        })
    },
    readingsPageChange(pInfo) {
      this.readingsPageingOptions.page = pInfo.pageNumber;
      this.readingsPageingOptions.pageSize = pInfo.pageSize;
      this.fillReadings();
    },
    fillReadings() {
      var parameters = {
        meterId: this.MeterId,
        loginEmail: this.getLoginName(),
        Options: this.readingsPageingOptions
      }

      axios.post('/Enquiries/getMeterReadings', parameters)
        .then(response => {
          if (response.status == 200) {
            this.readings = response.data.items;

            this.readingsTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => { return false; })
        .finally(() => { this.loading = false; });
    },
    historyPageChange(pInfo) {
      this.historyPageingOptions.page = pInfo.pageNumber;
      this.historyPageingOptions.pageSize = pInfo.pageSize;
      this.fillHistory();
    },
    fillHistory() {
      var parameters = {
        meterId: this.MeterId,
        loginEmail: this.getLoginName(),
        Options: this.historyPageingOptions
      }

      axios.post('/Enquiries/getMeterHistory', parameters)
        .then(response => {
          if (response.status == 200) {
            this.history = response.data.items;

            this.historyTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  return false; })
    },
  },
}
